// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Item_wrap__VKUaV","subTitle":"Item_subTitle__1f89e"};